// Banner.js
import React from 'react';
import { useLocation } from 'react-router-dom';

const Banner = ({ titleGraphic }) => {
  const location = useLocation();
  const isNotFound = location.pathname.includes('/not-found');

  // Construct the correct image URL relative to the site root
  const imageUrl = `/banner_graphics/${titleGraphic}`;

  return (
    <div className="banner">
      {titleGraphic && <img src={imageUrl} alt="Banner" className="banner-image" />}
      
      {/* Only show "Welcome" if there is no banner image */}
      {!titleGraphic && !isNotFound && (
        <div className="banner-welcome">
          <h1>Welcome</h1>
        </div>
      )}
    </div>
  );
};

export default Banner;
